import { IVSNFeeTokenCollection } from "@models";

export const visionBenefitToggleTexts: VSNOptinToggleTexts = {
	heading: {
		suffix: "web3_vsn_benefit_toggle_heading_suffix",
		prefix: "web3_vsn_benefit_toggle_heading_prefix",
		discount: 0.2
	},
	subheading: "fee_discount_banner_subtitle",
	insufficient: "fee_discount_banner_insufficent_funds",
	failed: "fee_discount_banner_failed_loading"
};

export interface VSNOptinToggleViewModel {
	vsnFeeCollection: IVSNFeeTokenCollection;
	texts: VSNOptinToggleTexts;
}

export interface VSNOptinToggleTexts {
	heading: VSNOptinToggleHeading;
	subheading: string;
	insufficient: string;
	failed: string;
}

export interface VSNOptinToggleHeading {
	prefix: string;
	suffix: string;
	discount: number;
}

export enum WEB3_FEE_BENEFFIT_FLOW {
	limitOrderBuy = "limitOrderBuy",
	limitOrderSell = "limitOrderSell",
	marketOrderBuy = "marketOrderBuy",
	marketOrderSell = "marketOrderSell",
	savingsPlan = "savingsPlan",
	swap = "swap"
}

export interface Web3VSNFeeBenefitFF {
	[WEB3_FEE_BENEFFIT_FLOW.limitOrderBuy]: boolean;
	[WEB3_FEE_BENEFFIT_FLOW.limitOrderSell]: boolean;
	[WEB3_FEE_BENEFFIT_FLOW.marketOrderBuy]: boolean;
	[WEB3_FEE_BENEFFIT_FLOW.marketOrderSell]: boolean;
	[WEB3_FEE_BENEFFIT_FLOW.savingsPlan]: boolean;
	[WEB3_FEE_BENEFFIT_FLOW.swap]: boolean;
}
